module.exports = __webpack_public_path__ + "06d8df32ca1bd7f70942070331e3771c.jpeg";